export default "__VITE_ASSET__YjhWhyo8__"